import { doc, writeBatch } from 'firebase/firestore';
import { firestore } from '@/lib/firebase';

export const ENGINEERING_PAGE = 'EngineeringPage';

/** Sends the box app's legacy FanVision remote-control command — the same
 *  write the iOS app makes: ProductionCommands/{boxName} =
 *  { FIELD_ROW: '<channel>|<page>|<clipUrl>|<cc>' }. The box acts on it and
 *  deletes the doc as its ack. Page switches only apply when the box's
 *  page-transition pref is 'Auto'. Rules allow boxes/admin users to write
 *  FIELD_ROW only. */
function sendFieldRow(boxNames: string[], fieldRow: string) {
  const batch = writeBatch(firestore);
  for (const name of boxNames) {
    batch.set(doc(firestore, 'ProductionCommands', name), {
      FIELD_ROW: fieldRow,
    });
  }
  return batch.commit();
}

export function sendPageCommand(boxNames: string[], page: string) {
  return sendFieldRow(boxNames, `|${page}|`);
}

/** Closed captions on/off — the 4th FIELD_ROW field ("|||cc_on"). */
export function sendCcCommand(boxNames: string[], on: boolean) {
  return sendFieldRow(boxNames, `|||${on ? 'cc_on' : 'cc_off'}`);
}
